/**
 * The explanation behind a screen's Help action (`SectionHeader help`) or a
 * form section's help icon: a plain dialog with a title, the copy and a Close
 * button. A dialog rather than a popover because the Help action has no
 * anchor on a phone (it lives in the overflow menu) and the copy is long
 * enough to need its own scroll.
 */

import React from 'react';
import { useTranslate } from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';

export interface HelpDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  /** The explanation: paragraphs and short lists, one column. */
  children: React.ReactNode;
}

export const HelpDialog: React.FC<HelpDialogProps> = ({ open, onClose, title, children }) => {
  const translate = useTranslate();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>{children}</Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          {translate('ra.action.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HelpDialog;
